import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
  type EnumeratedLiteralSubsetType,
} from "./enumeratedLiterals";
import { type TimeGranularity } from "./time-granularity";

export const AttributionWindows = enumeratedLiterals(
  {
    one: "1",
    three: "3",
    seven: "7",
    fourteen: "14",
    thirty: "30",
    sixty: "60",
    ninety: "90",
    infinity: "infinity",
  } as const,
  {
    getLabels: (accessors) =>
      ({
        [accessors.ONE]: "1 day",
        [accessors.THREE]: "3 day",
        [accessors.SEVEN]: "7 day",
        [accessors.FOURTEEN]: "14 day",
        [accessors.THIRTY]: "30 day",
        [accessors.SIXTY]: "60 day",
        [accessors.NINETY]: "90 day",
        [accessors.INFINITY]: "Infinite",
      } as const),
    getOrder: (accessors) => [
      accessors.ONE,
      accessors.THREE,
      accessors.SEVEN,
      accessors.FOURTEEN,
      accessors.THIRTY,
      accessors.SIXTY,
      accessors.NINETY,
      accessors.INFINITY,
    ],
    getSubsets: (accessors) =>
      ({
        hourly: [accessors.ONE] as const,
        daily: [
          accessors.NINETY,
          accessors.SIXTY,
          accessors.THIRTY,
          accessors.FOURTEEN,
          accessors.SEVEN,
          accessors.THREE,
          accessors.ONE,
        ] as const,
        monthly: [
          accessors.NINETY,
          accessors.SIXTY,
          accessors.THIRTY,
          accessors.FOURTEEN,
          accessors.SEVEN,
          accessors.THREE,
          accessors.ONE,
        ] as const,
        weekly: [
          accessors.NINETY,
          accessors.SIXTY,
          accessors.THIRTY,
          accessors.FOURTEEN,
          accessors.SEVEN,
          accessors.THREE,
          accessors.ONE,
        ] as const,
      } as const),
  },
);

export type AttributionWindow<
  T extends TimeGranularity | undefined = undefined,
> = T extends TimeGranularity
  ? EnumeratedLiteralSubsetType<T, typeof AttributionWindows>
  : EnumeratedLiteralType<typeof AttributionWindows>;
